var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashDispensed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M200,17.6H0v114h43V80.4H31.3V68.7h137.5v11.7H157v51.1h43V17.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M54.7,153.4h1.8c15,0,27.2,12.2,27.2,27.2v1.8h32.5v-1.8c0-15,12.2-27.2,27.2-27.2h1.8v-73H133 c0.3,1.9,0.5,3.9,0.5,5.9c0,18.5-15,33.5-33.5,33.5s-33.5-15-33.5-33.5c0-2,0.2-3.9,0.5-5.9H54.7V153.4z M119.3,143.3H80.7v-11.7 h38.7v11.7H119.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M72,180.6c0-8.5-7-15.5-15.5-15.5h-1.8v17.3H72V180.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M128,180.6v1.8h17.3v-17.3h-1.8C134.9,165.1,128,172.1,128,180.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M78.2,86.3c0,12,9.8,21.8,21.8,21.8s21.8-9.8,21.8-21.8c0-2-0.3-4-0.8-5.9H79C78.5,82.3,78.2,84.3,78.2,86.3 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashDispensed);
export default __webpack_public_path__ + "static/media/cash-dispensed.f23b8de05e39e2cc63262e6b0a9ac18f.svg";
export { ForwardRef as ReactComponent };